export interface IStartTripDto {
    datetime?: string;
    finishTripsInProgress?: boolean;
    message?: string;
}
